import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Catalog } from 'models/catalog';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'da-catalog-item',
    templateUrl: './catalog-item.component.html',
    styleUrls: ['./catalog-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CatalogItemComponent implements OnInit {
    @Input() catalog: Catalog;
    public dynamicParameter: string;
    public catalogImage: string;
    public alt: string = '';

    private _$catalogImage: BehaviorSubject<{}> = new BehaviorSubject<{}>(null);
    private _$catalog: BehaviorSubject<Catalog> = new BehaviorSubject<Catalog>(null);

    constructor() { }

    public get catalogImage$(): Observable<{}> {
        return this._$catalogImage.asObservable();
    }

    public get catalog$(): Observable<Catalog> {
        return this._$catalog.asObservable();
    }

    ngOnInit() {
        this._$catalog.next(this.catalog);
        if (this.catalog && this.catalog.image) {
            this.catalogImage = environment.APIEndpoint + this.catalog.image.uri;
            this._$catalogImage.next(this.catalogImage);

            if (this.catalog.image && this.catalog.image.fileName) this.alt = this.catalog.image.fileName;
        }
    }
}
